import { FormDatePicker, FormFieldMethods, FormSelect, FormTextField, Grid, requiredRule } from '@gcl/react-core';
import * as React from 'react';
import { DetailPageAccessMode } from '@app/detailPageLayout.models';
import { LabelWithMessage } from '@common/LabelWithMessage';
import { EProjectRequestFormKeys, mockDataProjectRegion, mockDataProjectType } from './projectRequest.models';

interface IProjectRequestDetailFormGeneralInfoProps {
  isReadOnly: boolean;
  mode: DetailPageAccessMode;
  id: number;
  formFieldMethods: FormFieldMethods;
  disabledFields?: EProjectRequestFormKeys[];
}

export const ProjectRequestDetailFormGeneralInfo: React.FunctionComponent<
  IProjectRequestDetailFormGeneralInfoProps
> = ({ isReadOnly, mode, id, formFieldMethods, disabledFields = [] }) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.PROJECT_NO} text="Project No." required />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.PROJECT_NO}
          rules={requiredRule}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.PROJECT_NO)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.PROJECT_TYPE} text="Project Type" required />
        <FormSelect
          options={mockDataProjectType}
          displayFieldName="type"
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.PROJECT_TYPE}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.PROJECT_TYPE)}
          rules={requiredRule}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.PROJECT_REGION} text="Project Region" required />
        <FormSelect
          options={mockDataProjectRegion}
          displayFieldName="region"
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.PROJECT_REGION}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.PROJECT_REGION)}
          rules={requiredRule}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.PROJECT_TITLE} text="Project Title" required />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.PROJECT_TITLE}
          rules={requiredRule}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.PROJECT_TITLE)}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.ADDRESS} text="Address" required />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.ADDRESS}
          disabled={isReadOnly}
          rules={requiredRule || disabledFields.includes(EProjectRequestFormKeys.ADDRESS)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.DESCRIPTION} text="Description" required />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.DESCRIPTION}
          disabled={isReadOnly}
          rules={requiredRule || disabledFields.includes(EProjectRequestFormKeys.DESCRIPTION)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.TEL} text="Tel" />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.TEL}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.TEL)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.FAX} text="Fax" />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.FAX}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.FAX)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.EMAIL} text="Email" required />
        <FormTextField
          formFieldMethods={formFieldMethods}
          id={EProjectRequestFormKeys.EMAIL}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.EMAIL)}
          rules={requiredRule}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.START_DATE} text="Start Date" required />
        <FormDatePicker
          id={EProjectRequestFormKeys.START_DATE}
          formFieldMethods={formFieldMethods}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.START_DATE)}
          rules={requiredRule}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LabelWithMessage labelFor={EProjectRequestFormKeys.END_DATE} text="End Date" required />
        <FormDatePicker
          id={EProjectRequestFormKeys.END_DATE}
          formFieldMethods={formFieldMethods}
          disabled={isReadOnly || disabledFields.includes(EProjectRequestFormKeys.END_DATE)}
          rules={requiredRule}
        />
      </Grid>
    </>
  );
};
